import mapboxgl from "mapbox-gl";
import { useProjectClustersLayer } from "../hooks/useProjectClustersLayer";
import { GeospatialProject } from "../hooks/useGeospatialProjectsData";

interface ProjectClustersLayerProps {
  map: mapboxgl.Map | null;
  projects: GeospatialProject[];
  onProjectSelect?: (project: GeospatialProject | null) => void;
}

export const ProjectClustersLayer = ({
  map,
  projects,
  onProjectSelect,
}: ProjectClustersLayerProps) => {
  useProjectClustersLayer({ map, projects, onProjectSelect });
  return null;
};

